export default __webpack_public_path__ + "static/media/027-linkedin.b610683b.svg";